import React from "react";
import { Row, Col, Tabs, Tab } from "react-bootstrap";
import img from "../../ui/templates/Rectangle.png";
import { Box, Card, Grid } from "@material-ui/core";
import { ButtonDanger } from "../../ui/templates/buttons";
import logo from "../../ui/templates/Logo.png";

export default ({
  onRedirect,
  teams,
  upcomingTeams,
  pastTeams,
  onRedirectToTeamByID,
  isLoading,
}) => {
  const nonActiveTabStyle = {
    color: "#E00000",
  };

  return (
    <Box className="px-3">
      {teams && (
        <Box>
          <Row>
            <Col lg={12} md={12} sm={12} xs={12}>
              <Tabs
                className="customTabs"
                defaultActiveKey="upcoming"
                id="uncontrolled-tab-example"
              >
                <Tab eventKey="upcoming" title="Upcoming">
                  <Box className="team-button" mt={2} mb={2}>
                    <ButtonDanger
                      variant="contained"
                      text={"Create Team"}
                      onClick={onRedirect}
                    />
                  </Box>
                  {upcomingTeams.length > 0 && (
                    <Box className="row">
                      {upcomingTeams?.map((team, index) => (
                        <TeamCard
                          team={team}
                          key={index}
                          onClick={onRedirectToTeamByID}
                        />
                      ))}
                    </Box>
                  )}
                </Tab>
                <Tab eventKey="past" title="Past ">
                  {pastTeams.length > 0 && (
                    <Box className="row">
                      {pastTeams.map((team, index) => (
                        <TeamCard
                          team={team}
                          key={index}
                          onClick={onRedirectToTeamByID}
                        />
                      ))}
                    </Box>
                  )}
                </Tab>
              </Tabs>
            </Col>
          </Row>
        </Box>
      )}
      <style>
        {`
          .nav-link:not(.active) {
            color: ${nonActiveTabStyle.color} !important;
            border: none !important;
          }

          .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
            border-bottom-color: transparent !important;
          }

          .nav-tabs .nav-link {
            position: relative;
          }

          .nav-tabs .nav-link::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 2px; 
            background-color: #E00000; 
            transform: scaleX(0); 
            transition: transform 0.3s ease; 
          }

          .nav-tabs .nav-link.active::after {
            transform: scaleX(1);
          }
          @media only screen and (max-width: 768px) {
            .nav-tabs {
              flex-direction: column;
            }
          }
        `}
      </style>
    </Box>
  );
};

const TeamCard = ({ team, onClick }) => {
  const dotifyDescription = () => {
    const screenWidth = window.innerWidth;
    const maxDescriptionLength = screenWidth < 768 ? 50 : 200;
    return team?.team_description.length > maxDescriptionLength
      ? `${team?.team_description.slice(0, maxDescriptionLength)}...`
      : team?.team_description;
  };
  return (
    <Grid container id="team_container_grid" alignItems="top">
      <Grid item xs={12} sm={4} md={3} className="image_container_grid">
        <Box
          mr={3}
          mb={3}
          border="1px solid #DCDCDC"
          fontSize={0}
          borderRadius={5}
          height={250}
          width={250}
          justifyContent="center"
          alignItems="center"
          display="flex"
        >
          <img
            alt={team.team_name}
            src={team?.image || logo}
            style={{
              maxWidth: "200px",
              maxHeight: "200px",
              margin: 0,
            }}
          />
        </Box>
      </Grid>
      <Grid item xs={12} sm={8} md={9}>
        <Box>
          <Box mb={2}>
            <h3 className="team-heading">{team?.team_name}</h3>
          </Box>
          <Box className="team-text" mb={2}>
            <Box fontWeight="bold">Description:</Box>
            <div
              dangerouslySetInnerHTML={{ __html: dotifyDescription() }}
              style={{ whiteSpace: "pre-wrap" }}
            />
          </Box>
          <Box className="team-card">
            <Card elevation={0}>
              <Box
                display="flex"
                bgcolor="#F7F7F7"
                border="1px solid #DCDCDC"
                alignItems="center"
                p={1.5}
                pl={2}
                pr={2}
                mb={2.2}
                width="100%"
                borderRadius={5}
              >
                <img
                  alt={team.team_name}
                  src={team?.event_logo || img}
                  width="50px"
                  height="50px"
                />
                <Box ml={2} fontWeight="bold">
                  {team.event_title}
                </Box>
              </Box>
            </Card>
          </Box>
          <Box className="team-button">
            <ButtonDanger
              btnShowTeam
              text="Show Team"
              onClick={() => onClick(team.team_id)}
            >
              Show the Team
            </ButtonDanger>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};
